import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Stack,
  Select,
  Link,
} from '@chakra-ui/react'
import { TrHeader } from '../styles'
import { Skeleton } from '@chakra-ui/react'
import { cnpjMask } from '../../../../utils/cnpjMask'
import { TrUsage } from './TrUsage'
import { useCallback, useEffect, useState } from 'react'
import { baseURL } from '../../../../services/api'

export function HeaderModal({
  dadosContabilidade,
  label,
  dadosModal,
  isRemessa = false,
  loading,
  dadosFat,
  setVerifyLength,
  handleSequencia,
  handleCodProd,
}) {
  const [initialValues, setInitialValues] = useState({})
  const [allData, setAllData] = useState([])

  const numNota = dadosModal[0]?.numero_nota
  const getInputInitialValues = useCallback(async () => {
    try {
      const { data } = await baseURL.get(
        `/pedido/lista-informacoes-update-icms/${numNota}`
      )

      setInitialValues(data)
    } catch (error) {
      console.log(error)
    }
  }, [numNota, setInitialValues])

  useEffect(() => {
    getInputInitialValues()
  }, [numNota, getInputInitialValues])

  useEffect(() => {
    const data = dadosModal.map((item) => {
      return { ...item, ...initialValues }
    })
    setAllData(data)
  }, [dadosModal, initialValues])

  return (
    <>
      {loading ? (
        <Stack>
          <Skeleton height="80px">
            <div>contents wrapped</div>
            <div>won't be visible</div>
          </Skeleton>
          <Skeleton height="50px" />
          <Skeleton height="50px" />
          <Skeleton height="50px" />
        </Stack>
      ) : (
        <>
          <TableContainer>
            <Text
              paddingLeft="24.3px"
              fontSize={{ base: '1.2rem', md: '1.4rem', lg: '1.6rem' }}
              fontWeight="bold"
              color="white"
              bgColor="#5292a2"
            >
              {label}
            </Text>

            <Table variant="simple">
              <Thead bgColor="#ececec">
                <Tr>
                  <Th color="#5292a2">Pedido</Th>
                  <Th color="#5292a2">Tipo de uso</Th>
                  <Th color="#5292a2">Razão social</Th>
                  <Th color="#5292a2">CNPJ</Th>
                  <Th color="#5292a2">IE</Th>
                  <Th color="#5292a2">Cidade</Th>
                  <Th color="#5292a2">Estado</Th>
                  <Th color="#5292a2">Valor total da nota</Th>
                  <Th color="#5292a2">Valor frete</Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td fontWeight="bold" color="#666666cc">
                    {dadosContabilidade?.numero_pedido}
                  </Td>
                  <Td fontWeight="bold" color="#666666cc">
                    {dadosContabilidade?.tipo_uso}
                  </Td>
                  <Td fontWeight="bold" color="#666666cc">
                    {isRemessa
                      ? dadosContabilidade?.faturamento_2?.slice(0, 15) + '...'
                      : dadosContabilidade?.faturamento.slice(0, 15) + '...'}
                  </Td>
                  <Td color="#666666cc">
                    {isRemessa
                      ? cnpjMask(dadosContabilidade?.cnpj_2)
                      : cnpjMask(dadosContabilidade?.cnpj)}
                  </Td>
                  <Td color="#666666cc">
                    {isRemessa
                      ? dadosContabilidade?.inscricao_est_2
                      : dadosContabilidade?.inscricao_est}
                  </Td>
                  <Td color="#666666cc">
                    {isRemessa
                      ? dadosContabilidade?.estado_2
                      : dadosContabilidade?.estado}
                  </Td>
                  <Td color="#666666cc">
                    {isRemessa
                      ? dadosContabilidade?.estado_2
                      : dadosContabilidade?.estado}
                  </Td>
                  <Td color="#666666cc">
                    {parseFloat(dadosContabilidade?.valor_total).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Td>
                  <Td color="#666666cc">
                    {parseFloat(dadosContabilidade?.valor_frete).toLocaleString(
                      'pt-br',
                      {
                        style: 'currency',
                        currency: 'BRL',
                      }
                    )}
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
          <TableContainer>
            <Table variant="simple">
              <Thead bgColor="#5292a2">
                <TrHeader>
                  <Th>Cód</Th>
                  <Th>Descrição</Th>
                  <Th>NCM</Th>
                  <Th>Origem</Th>
                  <Th>Qtd.</Th>
                  <Th>Vlr un.</Th>
                  <Th>Vlr total</Th>
                  <Th>Rateio Frete</Th>
                  {/* <Th>NAC/IMP</Th> */}
                  <Th>TEM ST?</Th>
                  <Th>CEST</Th>
                  <Th>Legislação</Th>
                  <Th>BC ICMS ST</Th>
                  <Th>IVA</Th>
                  <Th>%ICMS Dest</Th>
                  <Th>%FCP</Th>
                  <Th>VALOR FCP</Th>
                  <Th>%ICMS Orig</Th>
                  <Th>Vlr ICMS</Th>
                  <Th>Vlr ICMS + FCP</Th>
                  <Th></Th>
                </TrHeader>
              </Thead>

              <Tbody>
                {allData?.map((info, index) => (
                  <TrUsage
                    index={index}
                    info={info}
                    dadosContabilidade={dadosContabilidade}
                    dadosFat={dadosFat}
                    getInputInitialValues={getInputInitialValues}
                    setVerifyLength={setVerifyLength}
                    handleSequencia={handleSequencia}
                    handleCodProd={handleCodProd}
                  />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </>
      )}
    </>
  )
}
